module.exports = __webpack_public_path__ + "static/media/alerte_orange_point.6049ab55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/tunnel/components/@sharded/notifications/alerte_orange_point.svg
// module id = 544
// module chunks = 0